import filter from 'lodash/filter';
import head from 'lodash/head';

export class CallForHelpService {
	constructor($resource, ApiService) {
		'ngInject';

		this.$resource = $resource;
		this.apiService = ApiService;

		this.callForHelpResourceUrl = this.apiService.getResourceUrl('menus/CallForHelp');
		this.callForHelpFilterResourceUrl = this.apiService.getResourceUrl('menus/CallForHelp/filter');

		this.callForHelpResource = this.$resource(this.callForHelpResourceUrl);
		this.callForHelpFilterResource = this.$resource(this.callForHelpFilterResourceUrl);
	}

	_getOverviewDetailsObject(details) {
		return {
			contentId: details.content_id,
			menuId: details.menu_id,
			displayName: details.display_name,
			name: details.name,
			title: details.title,
			description: details.description
		}
	}

	_getHoursOfOperationDetails(value) {
		return {
			startTime: value.start_time,
			endTime: value.end_time,
			isAllDay: value.is_all_day
		}
	}

	_getPhoneDetailsObject(values) {
		return values.map(({ extn, number }) => ({ extn, number }));
	}

	_getCountyObject(values) {
		return values.map(value => ({
			id: value.service_area_id,
			name: `${value.name} (${value.state_code}) (${value.service_area_type})`
		}));
	}

	_getContentObject(values) {
		let details = filter(values, ['name', 'CallForHelp']);
		return _getContentData.call(this, head(details).values);

		function _getContentData(data) {
			return data.map(value => ({
				countyName: this._getCountyObject(value.service_area),
				daysOfOperation: value.days_of_operation,
				email: value.email,
				hoursOfOperation: this._getHoursOfOperationDetails(value.hours_of_operation),
				image: value.image,
				name: value.name,
				phone: this._getPhoneDetailsObject(value.phone),
				url: value.url
			}));
		}
	}

	_getCountyListObject(values) {
		let details = filter(values, ['name', 'serviceArea']);

		return _getCountyData(head(details).values);

		function _getCountyData(data) {
			return data.map(value => ({
				id: value.service_area_id,
				label: `${value.name} (${value.state_code}) (${value.service_area_type})`
			}));
		}
	}

	/**
	 * function to get call for help content
	 * @return {object} [information related to call for help]
	 */

	getCallForHelpDetails(details) {
		return {
			count: details.data.count,
			menuOverviewDetails: this._getOverviewDetailsObject(details.data.menuOverviewDetails),
			countyList: this._getCountyListObject(details.data.content),
			details: this._getContentObject(details.data.content)
		}
	}

	getCallForHelpFilterData({ id, filterDetails: { limit, pageId } }) {
		const promise = this.callForHelpFilterResource.get({
			service_area_id: id,
			limit,
			page_id: pageId
		}).$promise;

		return promise.then(details => this._getFilterDetailsObject(details))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	_getFilterDetailsObject(details) {
		let obj = {};
		obj.details = this._getContentObject([details.data]);
		if (details.data.hasOwnProperty('count')) {
			obj.count = details.data.count;
		}
		return obj;
	}
}


// WEBPACK FOOTER //
// ./src/app/components/transportation-call-for-help/transportation-call-for-help.service.js